module.exports = __webpack_public_path__ + "static/media/11.1817a5ca.jpg";